import { createRoutine } from 'redux-saga-routines'

export const SET = 'PROFILE_LAYOUT/SET'
export const CONTENT = createRoutine('PROFILE_LAYOUT/CONTENT')
